export interface IModule {
  /** 频道模块类型 */
  channelModuleType: string
  /** 频道模块名称 */
  channelModuleName: string
  /** 频道模块ID */
  channelModuleId: string
}
export enum ModuleMap {
  /** 首页 */
  HOME = '733352B312C14C24A410C3B6CE432AF0',
  /** 课程 */
  COURSE = 'DA445B4E5B1B402D922BE87753A650AC',
  /** 直播 */
  LIVE = '76DA288C7684487CA3478F8BC6C60343',
  /** 考试 */
  EXAM = 'DE8FCBA0047C430C8A4C110ACA406464',
  /** 面授班 */
  TRAIN = '726A7A5500E9452497DFDFB25DD09127',
  /** 资讯 */
  INFO = '18F1F4EECE1442C4B3205972C6759E61',
  /** 文库 */
  KNOWLEDGE = 'D5EE3B63E8124EC7B52D6D831073BF15',
  /** 专家中心 */
  PROFESSOR = '637D57362982459E85A8347E7655FB1F',
  /** 个人中心 */
  PERSONAL = 'E572FA9E37264F1F87B011A8F517A5BD',
}
export interface IModuleInfo {
  body: IModule[]
  code: number
  message: string
}
export interface IHomeInfo {
  /** 是否开启轮播图,0未开启，1已开启 */
  isOpenBanner: number
  /** 是否开启频道块,0未开启，1已开启 */
  isOpenChannel: number
  /** 是否开启栏目,0未开启，1已开启  */
  isOpenColumn: number
  /** 是否开启头条,0未开启，1已开启 */
  isOpenHeadline: number
  /** 是否开启飘窗,0未开启，1已开启 */
  isOpenRollWindow: number
  /** logo图片 */
  logoUrl: string
  /** 首页ID */
  pageId: string
  /** 展示样式 */
  showStyle: number
}

export interface IHomeGlobalInfo {
  body: IHomeInfo
  code: number
  message: string
}

export interface IOperationDetail {
  name: string
  operationCode: string
}
export interface IOperationBody {
  opertationList: IOperationDetail[]
  [x: string]: any
}
export interface IOperation {
  body: IOperationBody
  code: number
  message: string
}
